// The search box over the catalog tables; the page keeps its text with useUrlSearch.
import { MagnifyingGlass } from "@phosphor-icons/react";
import { Input } from "rizzui";

export function SearchBox({ label, placeholder, text, onChange, className }: { label: string; placeholder: string; text: string; onChange: (t: string) => void; className?: string }) {
  return (
    <Input
      className={className}
      type="search"
      aria-label={label}
      placeholder={placeholder}
      value={text}
      prefix={<MagnifyingGlass className="h-4 w-4 text-gray-500" />}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
